<template>
  <div id="past-events">

          <div class="past-events-container">

            <EventBlock :data="pastevents" />  

          </div>

          <infinite-loading :infinite-scroll-listen-for-event="true" @infinite="getPastEvents" spinner="waveDots">
            <div slot="no-more"></div>
            <NoData slot="no-results"
              :title="$t('nodatakeys.homepastevents.nodatatitle')"
              :description="$t('nodatakeys.homepastevents.nodatadesc')"
              anim="holacon-calender-lottie-v2-without-background"
              :loading="loading"
              :button="$t('nodatakeys.homepastevents.nodatabutton')"
              @btnClick="getPastEvents"
            />
          </infinite-loading>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="response.hasError" md-persistent>
      <i class="fa fa-exclamation-triangle"></i><span>{{ response.message }}</span>
    </md-snackbar>
    
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import InfiniteLoading from "vue-infinite-loading";
import NoData from "@/modules/NoData";
import EventBlock from "@/modules/EventBlock";

export default {
  name: "PastEvents",
  components: {
    EventBlock,
    InfiniteLoading,
    NoData
  },
  data() {
    return {
      pastevents: [],
      searchTerm: null,
      loading: false,
      moment,
      host: location.host == 'localhost:3000' ? 'https://live.holacon.com/' : 'https://' + location.host, 
      response: {
        message: null,
        validationErrors: [],
        hasError: false
      },
    };
  },

  methods: {

    async getPastEvents($state, reset) {
      var res = await axios.post("/Explore/SearchEvent", { skip: reset ? 0 : this.pastevents.length, take: 10, searchType: 2, searchTerm: this.searchTerm});
      if(res.data.hasError)
      {
        this.snackbar = { show: true, message: res.data.message };
      } 
      else
      {
        if (reset) {
          this.pastevents = res.data.data.items;
        } else {
          this.pastevents = [
            ...this.pastevents,
            ...res.data.data.items
          ];
        }
      } 
      try {
        if (res.data.data.items.length == 0) $state.complete();
        else $state.loaded();
      } catch (err) {}
      this.loading = false;
    },

  }
};
</script>

<style lang="less">
#past-events {
  background-color: transparent;
  margin-top: 30px;

  .past-events-container {
    display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      margin: 0px;
  }

}

@media (max-width: 768px) {
  #past-events {
    .past-events-container {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PastEvents.vue